<template>
    <kt-panel v-if="general_wage_setting_status != 'loading'">
        <kt-panel-body>
            <form id="update_setting_form">
                <kt-form-section>
                    <kt-row>
                        <kt-form-group class="col-12 col-sm-4 col-md-3">
                            <kt-form-label for="sms_price">
                                {{ $t('online_contract.wage_price') }}
                            </kt-form-label>
                            <kt-form-control
                                dir="rtl"
                                data-id="0"
                                name="sms_price"
                                placeholder="قیمت را به ریال وارد کنید"
                                v-model="general_wage_setting.wage_price"
                            >
                            </kt-form-control>
                        </kt-form-group>
                        <kt-form-group class="col-12 col-sm-4 col-md-3">
                            <kt-form-label for="sms_price">
                                {{ $t('notification.label.setTerminalForPay') }}
                            </kt-form-label>
                            <select
                                name="payment_gateway_id"
                                id="payment_gateway_id"
                                v-model="general_wage_setting.payment_gateway_id"
                                class="form-control kt-selectpicker"
                            >
                                <option>{{ $t('selectpicker.nothing') }}</option>
                                <option
                                    v-bind:key="index"
                                    v-for="(gateway, index) in gateways"
                                    v-bind:value="gateway.id"
                                    :selected="gateway.id === general_wage_setting.payment_gateway_id"
                                >
                                    {{ gateway.farsi_name }}
                                </option>
                            </select>
                        </kt-form-group>
                        <kt-form-action class="mt-4">
                            <kt-button
                                class="m-2"
                                size="md"
                                variant="success"
                                type="button"
                                @click="updateSetting"
                                id="update_setting_btn"
                            >
                                {{ $t('btn.update') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-row>
                </kt-form-section>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>
<script>
import {mapGetters} from "vuex";
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import {onlineContractService} from '@/common/api.service'
import toastr from "toastr";
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util';

export default {
    name: 'updateGeneralWageSetting',
    computed: {
        ...mapGetters('collective', [
            'gateways'
        ]),
        ...mapGetters('onlineContract', [
            'general_wage_setting',
            'general_wage_setting_status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        updateSetting() {
            let btn = $('#update_setting_btn')
            let form = $('#update_setting_form')

            form.validate({
                rules: {
                    title: {
                        required: true,
                    },
                }
            });

            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            onlineContractService.updateGeneralWageSetting(this.general_wage_setting).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message);
            }).finally(response => {
                KTUtil.scrollTop();
                KTApp.unprogress(btn)
            })
        },
    },
    mounted() {
        this.$store.dispatch('onlineContract/fetchGeneralWageSetting')
        this.$store.dispatch('collective/fetch').finally(() => {
            this.runSelectPicker()
        })
    }
}
</script>
<style scoped>

</style>